import { api } from 'app/app.api';

import {
  CreateConversationEmailApiArg,
  CreateConversationEmailApiResponse,
  ReadEmailReplyWindowResponse,
  ReadValidateEmailApiArg,
  ReadValidateEmailApiResponse,
  UpdateEmailReplyWindowArg,
} from './types/emailsApi.types';

export const emailsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    readValidateEmail: builder.query<
      ReadValidateEmailApiResponse,
      ReadValidateEmailApiArg
    >({
      query: ({ email }) => ({
        version: 1,
        path: `emails/validate/${email}`,
      }),
    }),
    readReplyWindow: builder.query<ReadEmailReplyWindowResponse, void>({
      query: () => ({
        version: 1,
        path: 'email/settings/reply-window',
      }),
    }),
    updateReplyWindow: builder.mutation<
      ReadEmailReplyWindowResponse,
      UpdateEmailReplyWindowArg
    >({
      query: (body) => ({
        version: 1,
        path: 'email/settings/reply-window',
        method: 'PUT',
        body,
      }),
    }),
    createConversationEmail: builder.mutation<
      CreateConversationEmailApiResponse,
      CreateConversationEmailApiArg
    >({
      query: (body) => ({
        version: 1,
        path: 'conversations/email',
        method: 'POST',
        body,
      }),
    }),
  }),
});
